import registerCustomCommand from './qRules/customCommands';
import { eventTypes } from './viewManager';

const registerCommand = (qRulesInstance) => (name, arg2, arg3) => {
    // if arg3 provided, assume arg 2 is a definition object
    const definition = (arg3 && arg2) || {};
    // action is the second argument if there are only 2 arguments
    const action = arg3 || arg2;

    if (!action) {
        throw new Error('registerCommand() requires at least two arguments.');
    }

    return registerCustomCommand(qRulesInstance, name, definition, action);
};

const makeqRulesHelper = (qRulesInstance) => ({
    registerCommand: registerCommand(qRulesInstance),
});

function createCustomCodeApi(
    formDataConnections,
    formDataSources,
    formViewManager,
    qRulesInstance,
    renderViewAsync,
) {
    const dataConnections = () => ({
        getDataConnection: (name) => formDataConnections.get(name) || null,
    });

    const dataSources = () => {
        const getDataSource = (name) => {
            try {
                return formDataSources.getDom(name);
            } catch (e) {
                return null;
            }
        };

        return {
            getDataSource,
        };
    };

    const viewManager = () => {
        const addEventListener = (type, listener) => {
            formViewManager.addEventListener(type, listener);
        };

        const currentViewName = () => formViewManager.currentViewName();

        return {
            addEventListener,
            currentViewName,
            // DEPRECATED
            eventType: eventTypes,
            eventTypes,
            renderViewAsync,
        };
    };

    return {
        dataConnections,
        dataSources,
        viewManager,
        qRules: () => makeqRulesHelper(qRulesInstance),
    };
}

export default createCustomCodeApi;
